// extracted by mini-css-extract-plugin
module.exports = {"root":"cultural-objects-page_root__sm1rF","cards":"cultural-objects-page_cards__aKyFi"};